export default "/images/vendor/flag-icon-css/flags/4x3/nf.svg?7a4f3d1b34fa49f5a098666d39b3ba44";